($ => {

    if( $('.Breadcrumbs').length ) {

        $('.Breadcrumbs select').change(function(ev) {
            let path = $('.Breadcrumbs option:selected').data('path')
            window.location.href = path
        })

    }

})(jQuery)